import { render, staticRenderFns } from "./TableVolumes.vue?vue&type=template&id=618da2ee&lang=pug"
import script from "./TableVolumes.vue?vue&type=script&lang=js"
export * from "./TableVolumes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports